import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import LoginPage from '../pages/login/LoginPage';
import Layout from '../components/layout/Layout';
import ProtectedRoute from './ProtectedRoute';
import EmployeeList from '../pages/employee/EmployeeList';
import ProductList from '../pages/product/ProductList';
import StockList from '../pages/stock/StockList';
import PurchaseStockList from '../pages/purchase/PurchaseStockList';
import CustomerList from '../pages/customers/CustomerList';
import InvoiceList from '../pages/invoice/InvoiceList';
import PaymentList from '../pages/payment/PaymentList';
import InvoiceDetails from '../pages/invoice/InvoiceDetails';
import ReportPage from '../pages/report/ReportPage';
import CustomerBalanceDetail from '../pages/report/CustomerBalanceDetail';
import CompanyPage from '../pages/company/CompanyPage';
import DashboardPage from '../pages/dashboard/DashboardPage';
import InvoiceEmptyDetail from '../pages/report/InvoiceEmptyDetail';
// import ProtectedRoute from './ProtectedRoute';
// import Dashboard from '../pages/dashboard/Dashboard';
// import EmployeeList from '../pages/employee/EmployeeList';
// import LineList from '../pages/line/LineList';
// import CompanyList from '../pages/company/CompanyList';
// import TaskList from '../pages/task/TaskList';
// import LocationList from '../pages/location/LocationList';
// import ReceivedList from '../pages/received/ReceivedList';
// import NotesList from '../pages/notes/NotesList';
// import ReturnList from '../pages/return/ReturnList';
// import ProductList from '../pages/product/ProductList';
// import OrderList from '../pages/order/OrderList';
// import OrderDetails from '../pages/order/OrderDetails';
// import Settings from '../pages/settings/Settings';

const AppRoutes: React.FC = () => {
  const { auth } = useAuth();

  if (auth.isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        Loading...
      </div>
    );
  }

  return (
    <Router>
        <Routes>
        <Route 
          path="/login" 
          element={
            <LoginPage />
          } 
        />

        <Route
          path="/employees"
          element={
            <ProtectedRoute requiredRole={["admin"]} >
              <Layout role={auth.user?.role}>
                <EmployeeList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/products"
          element={
            <ProtectedRoute requiredRole={["admin"]} >
              <Layout role={auth.user?.role}>
                <ProductList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/stocks"
          element={
            <ProtectedRoute requiredRole={["admin"]} >
              <Layout role={auth.user?.role}>
                <StockList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

         <Route
          path="/purchase"
          element={
            <ProtectedRoute requiredRole={["admin"]} >
              <Layout role={auth.user?.role}>
                <PurchaseStockList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/customers"
          element={
            <ProtectedRoute requiredRole={["admin"]} >
              <Layout role={auth.user?.role}>
                <CustomerList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/orders"
          element={
            <ProtectedRoute requiredRole={["admin", "employee"]} >
              <Layout role={auth.user?.role}>
                <InvoiceList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/orders/:id"
          element={
            <ProtectedRoute requiredRole={["admin", "employee"]} >
              <Layout role={auth.user?.role}>
                <InvoiceDetails role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/received"
          element={
            <ProtectedRoute requiredRole={["admin", "employee"]} >
              <Layout role={auth.user?.role}>
                <PaymentList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports"
          element={
            <ProtectedRoute requiredRole={["admin"]} >
              <Layout role={auth.user?.role}>
                <ReportPage role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/:id"
          element={
            <ProtectedRoute requiredRole={["admin"]} >
              <Layout role={auth.user?.role}>
                <CustomerBalanceDetail role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/invoice-empty/:id"
          element={
            <ProtectedRoute requiredRole={["admin"]} >
              <Layout role={auth.user?.role}>
                <InvoiceEmptyDetail role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute requiredRole={["admin"]} >
              <Layout role={auth.user?.role}>
                <CompanyPage role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute requiredRole={["admin"]} >
              <Layout role={auth.user?.role}>
                <DashboardPage role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* <Route
          path="/dashboard"
          element={
            <ProtectedRoute requiredRole={["super_admin", "admin"]}>
              <Layout role={auth.user?.role}>
                <Dashboard role={auth.user?.role} name={auth.user?.name} />
              </Layout>
            </ProtectedRoute>
          }
        />

        

        

        <Route
          path="/company"
          element={
            <ProtectedRoute requiredRole={["super_admin", "admin"]} >
              <Layout role={auth.user?.role}>
                <CompanyList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/task"
          element={
            <ProtectedRoute requiredRole={["admin", "super_admin"]} >
              <Layout role={auth.user?.role}>
                <TaskList role={auth.user?.role}/>
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/location"
          element={
            <ProtectedRoute requiredRole={["super_admin"]} >
              <Layout role={auth.user?.role}>
                <LocationList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/received"
          element={
            <ProtectedRoute requiredRole={["admin", "super_admin"]} >
              <Layout role={auth.user?.role}>
                <ReceivedList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/notes"
          element={
            <ProtectedRoute requiredRole={["super_admin"]} >
              <Layout role={auth.user?.role}>
                <NotesList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/return"
          element={
            <ProtectedRoute requiredRole={["super_admin", "admin"]} >
              <Layout role={auth.user?.role}>
                <ReturnList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/product"
          element={
            <ProtectedRoute requiredRole={["super_admin", "admin"]} >
              <Layout role={auth.user?.role}>
                <ProductList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/orders"
          element={
            <ProtectedRoute requiredRole={["super_admin", "admin"]} >
              <Layout role={auth.user?.role}>
                <OrderList role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/orderDetails/:id"
          element={
            <ProtectedRoute requiredRole={["super_admin", "admin"]} >
              <Layout role={auth.user?.role}>
                <OrderDetails role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute requiredRole={["super_admin"]} >
              <Layout role={auth.user?.role}>
                <Settings role={auth.user?.role} />
              </Layout>
            </ProtectedRoute>
          }
        /> */}

      <Route 
          path="/" 
          element={<Navigate to="/dashboard" replace />} 
        />
        </Routes>
      </Router>
  );
};

export default AppRoutes; 